import styled, { keyframes } from "styled-components";

// Theme colors
export const colors = {
    shimmerGradient: "linear-gradient(94deg, #F0F0F5 33.03%, #FFF 48.93%, #F0F0F5 70.63%)",
};

export const shimmerAnimation = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

// The quick-checkout webview is launched by native at 30% screen height, so this
// container fills 100% of whatever (short) viewport it is given.
export const Container = styled.div(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    background: theme.colors[theme.colorMode].background_Primary,
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
    justifyContent: "flex-end",
}));

export const Line = styled.div<{ width?: number; height?: number }>`
    background: ${colors.shimmerGradient};
    background-size: 1000px 100%;
    animation: ${shimmerAnimation} 2s infinite linear;
    border-radius: ${({ theme }) => theme.cornerRadius.small};
    width: ${(props) => props.width ?? 100}%;
    height: ${(props) => props.height ?? 12}px;
`;

export const CartBlock = styled.div`
    padding-bottom: ${({ theme }) => theme.spacing.small};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const PaymentBlock = styled.div`
    padding-top: ${({ theme }) => theme.spacing.small};
    padding-bottom: ${({ theme }) => theme.spacing.medium};
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const LeftBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.xxSmall};
    margin-right: ${({ theme }) => theme.spacing.xLarge};
    width: 100%;
`;

export const RightBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;
